import { Box } from '@mui/material';
import React from 'react';
import logo from '../../assets/amazonLogo.png';
import cart from '../../assets/cart.png';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import location from '../../assets/location.png';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Header = () => {
	return (
		<>
			<Box style={{ background: '#232F3F', padding: 6 }}>
				<Box display={'flex'} justifyContent={'space-between'}>
					<Box style={{ display: 'flex', alignItems: 'center' }}>
						<DensityMediumIcon style={{ fontSize: 22, color: '#fff' }} />
						<img
							src={logo}
							style={{ height: 24, marginLeft: 5, marginTop: 8 }}
						/>
					</Box>
					<Box
						style={{ display: 'flex', alignItems: 'center', marginRight: 5 }}>
						<span
							style={{
								position: 'relative',
								fontSize: '17px',
								marginBottom: '17px',
								color: '#ff9900',
								marginRight: -26,
							}}>
							7
						</span>
						<img src={cart} style={{ height: 26 }} />
					</Box>
				</Box>
				<Box mr={'2px'} mt={'6px'} display={'flex'}>
					<input
						type='text'
						placeholder='Search Amazon'
						style={{ padding: '10px', width: '100%', borderRadius: 8 }}
					/>
					{/* <Box style={{ background: '#ff9900' }}>S</Box> */}
				</Box>
				<Box
					display='flex'
					sx={{
						padding: '2px',
						overflowX: 'auto', // Use 'auto' or 'scroll' instead of 'smooth'
						width: '100%',
						alignItems: 'center',
						whiteSpace: 'nowrap', // Ensures text stays in one line
					}}>
					<p
						style={{
							color: 'white',
							lineHeight: '8px',
							fontSize: 14,
							fontWeight: 500,
						}}>
						Deals
					</p>
					<p
						style={{
							color: 'white',
							marginLeft: 10,
							lineHeight: '8px',
							fontSize: 14,
							fontWeight: 500,
						}}>
						Amazon Basic
					</p>
					<p
						style={{
							color: 'white',
							marginLeft: 10,
							lineHeight: '8px',
							fontSize: 14,
							fontWeight: 500,
						}}>
						Music
					</p>
					<p
						style={{
							color: 'white',
							marginLeft: 10,
							lineHeight: '8px',
							fontSize: 14,
							fontWeight: 500,
						}}>
						Livestreams
					</p>
					<p
						style={{
							color: 'white',
							marginLeft: 10,
							lineHeight: '8px',
							fontSize: 14,
							fontWeight: 500,
						}}>
						Amazon Basic
					</p>
					<p
						style={{
							color: 'white',
							marginLeft: 10,
							lineHeight: '8px',
							fontSize: 14,
							fontWeight: 500,
						}}>
						Amazon Basic
					</p>
				</Box>
			</Box>
			<Box
				style={{ background: '#364759', padding: 8 }}
				display={'flex'}
				alignItems={'center'}>
				<img src={location} style={{ height: 20 }} />
				<span style={{ marginLeft: 5, fontSize: 13, color: 'white' }}>
					Deliver to India
				</span>
				<KeyboardArrowDownIcon style={{ color: 'white', marginTop: 5 }} />
			</Box>
		</>
	);
};

export default Header;
